import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    margin-block-start: auto;
    padding-block: var(--spacing-1);
    padding-inline: var(--spacing-2) calc(var(--spacing-3) / 2);
    border: 1px solid var(--color-platinum-light);
    border-radius: 3px;

    @supports not (padding-block: 0) {
        padding: var(--spacing-1) calc(var(--spacing-3) / 2) var(--spacing-1) var(--spacing-2);
    }
`;

export const Content = styled.div`
    display: flex;
    gap: var(--spacing-1);
`;

export const Title = styled.span`
    margin-right: var(--spacing-1);
    font-family: var(--font-book);
    font-size: 1.4rem;
    line-height: 2rem;
    color: var(--color-platinum-dark);
`;

export const Code = styled.span`
    font-family: var(--font-bold);
    font-size: 1.4rem;
    line-height: 2rem;
    color: var(--color-midnight);
`;
